module.exports = __webpack_public_path__ + "img/bell_4.705aee5f.jpg";